export default __webpack_public_path__ + "static/media/documentation.014ebef5.png";